import { motion } from 'framer-motion'
import { ReactNode } from 'react'

interface MotionDivProps {
  children: ReactNode
  delay?: number
  className?: string
  direction?: 'up' | 'down'
  exit?: boolean
  enterDuration?: number
  exitDuration?: number
  ease?: "linear" | "easeIn" | "easeOut" | "easeInOut" | "circIn" | "circOut" | "circInOut"
}

export const MotionDiv = ({
  children,
  delay = 0,
  className = '',
  direction = 'up',
  exit = true,
  enterDuration = 0.12,
  exitDuration = 0.08,
  ease = "easeOut"
}: MotionDivProps) => {
  const initialY = direction === 'up' ? 20 : -20
  const exitY = direction === 'up' ? -20 : 20

  const variants = {
    initial: { 
      opacity: 0, 
      y: initialY
    },
    animate: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: enterDuration,
        ease: ease,
        delay
      }
    },
    exit: exit ? {
      opacity: 0,
      y: exitY,
      transition: {
        duration: exitDuration,
        ease: ease
      }
    } : {}
  }

  return (
    <motion.div
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      className={className}
    >
      {children}
    </motion.div>
  )
}

export default MotionDiv